import { Type } from "class-transformer";
import { BaseModel } from "../base.model";
import { User } from "../user/user.model";

export class Reviewable extends BaseModel {
  reviewedByUserId?: string;
  @Type(() => User)
  reviewedBy?: User;
  @Type(() => Date)
  reviewedOn?: Date;
}
